'use strict';

import {SectionCtrl} from "./sectionctrl.js";

export class SectionA2DeclarationsCtrl extends SectionCtrl
{
	text = {
		before: {
			key: 'a2_declarations_before',
			on: false,
			value: null
		},
		after: {
			key: 'a2_declarations_after',
			on: false,
			value: null
		}
	};
	
	$onInit(){
		if(typeof(this.section.instructions) !== 'undefined'){
			for(let prop in this.text){
				if(typeof(this.section.instructions[this.text[prop].key]) !== 'undefined' && this.section.instructions[this.text[prop].key].value !== ''){
					this.text[prop].on = true;
					this.text[prop].value = this.section.instructions[this.text[prop].key].value;
				}
			}
		}
	}
}

